/* TCH Service — v5 : traduction des pages, simulateur 4x, bandeau des marques, séparateurs, contact */
document.addEventListener('DOMContentLoaded',function(){
  var LANG='fr';try{if(localStorage.getItem('tchLang')==='en')LANG='en';}catch(e){}
  var EN=window.TCHX_EN||{},EN2=window.TCHX_EN2||{};
  for(var k in EN2)EN[k]=EN2[k];
  EN['Mail']='Email';
  var T=function(n){if(window.tchxTranslate)window.tchxTranslate(n);};
  var SNAP='https://snapchat.com/t/d4GEZ0eP';

  /* Bandeau « Luxe et premium » retiré */
  document.querySelectorAll('.tchx-luxe').forEach(function(n){n.remove();});

  /* Simulateur 4x : le montant suit le curseur, où que soit la carte */
  document.querySelectorAll('#tchxRange').forEach(function(r){
    var card=r.closest('.tchx-card')||document;
    var f=new Intl.NumberFormat(LANG==='en'?'en-IE':'fr-FR',{style:'currency',currency:'EUR',minimumFractionDigits:0,maximumFractionDigits:2});
    function upd(){
      var v=+r.value,q=Math.round(v*25)/100,last=Math.round((v-q*3)*100)/100;
      var amt=card.querySelector('#tchxAmt');if(amt)amt.textContent=f.format(v);
      var cells=card.querySelectorAll('.tchx-split b');
      if(cells.length===4){cells[0].textContent=f.format(q);cells[1].textContent=f.format(q);cells[2].textContent=f.format(q);cells[3].textContent=f.format(last);}
      r.setAttribute('aria-valuetext',f.format(v));
    }
    r.addEventListener('input',upd);r.addEventListener('change',upd);upd();
  });

  /* Nouveau lien Snapchat */
  document.querySelectorAll('a[href*="snapchat.com"]').forEach(function(a){a.setAttribute('href',SNAP);});

  /* Bandeau « Ils nous ont fait confiance » : losanges entre les marques */
  document.querySelectorAll('.brands .brand-track').forEach(function(t){
    if(t.querySelector('i'))return;
    t.querySelectorAll('span').forEach(function(s){var i=document.createElement('i');i.setAttribute('aria-hidden','true');s.after(i);});
  });

  /* Séparateur entre le devis et la suite */
  var dv=document.getElementById('devis');
  if(dv&&!document.querySelector('.tchx-sep:not(.auto)')){var s=document.createElement('div');s.className='tchx-sep';s.setAttribute('aria-hidden','true');s.innerHTML='<span></span><i></i><span></span>';dv.parentNode.insertBefore(s,dv.nextSibling);}

  /* Cartes réseaux dans le contact */
  var ICON={
    ig:'<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r=".7" fill="currentColor"/></svg>',
    mail:'<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="1.5"/><path d="M3 7l9 6 9-6"/></svg>',
    snap:'<svg viewBox="0 0 24 24"><path d="M12 3.2c3 0 5 2.2 5 5.1v2.2l1.5-.5c.5-.1.9.4.6.8-.5.6-1.4.9-2.1 1.1.6 1.5 1.9 2.8 3.4 3.3.4.1.4.7 0 .8-.8.3-1.8.4-2.2.6-.2.4-.1 1.1-.6 1.2-.7.1-1.6-.2-2.5.2-.8.4-1.6 1.5-3.1 1.5s-2.3-1.1-3.1-1.5c-.9-.4-1.8-.1-2.5-.2-.5-.1-.4-.8-.6-1.2-.4-.2-1.4-.3-2.2-.6-.4-.1-.4-.7 0-.8 1.5-.5 2.8-1.8 3.4-3.3-.7-.2-1.6-.5-2.1-1.1-.3-.4.1-.9.6-.8l1.5.5V8.3c0-2.9 2-5.1 5-5.1z"/></svg>'
  };
  var cards='<a class="tchx-soc" href="https://instagram.com/tchservice" target="_blank" rel="noopener"><span class="ic">'+ICON.ig+'</span><b>Instagram</b><span class="h">@tchservice</span></a>'+
    '<a class="tchx-soc" href="mailto:tchservice25@gmail.com"><span class="ic">'+ICON.mail+'</span><b>Mail</b><span class="h">tchservice25@gmail.com</span></a>'+
    '<a class="tchx-soc" href="'+SNAP+'" target="_blank" rel="noopener"><span class="ic">'+ICON.snap+'</span><b>Snapchat</b><span class="h">tch_service</span></a>';
  [document.querySelector('#contact .contact-grid'),document.querySelector('.tp-contact')].forEach(function(grid){
    if(!grid||grid.parentNode.querySelector('.tchx-socials'))return;
    var box=document.createElement('div');box.className='tchx-socials';box.innerHTML=cards;
    grid.parentNode.insertBefore(box,grid);
    var info=grid.querySelector('.contact-info');if(info)info.remove();
  });

  /* Séparateurs automatiques entre deux sections de même couleur */
  function bgOf(el){var c=getComputedStyle(el).backgroundColor;if(!c||c==='transparent'||c==='rgba(0, 0, 0, 0)')c=getComputedStyle(document.body).backgroundColor;return c;}
  function seps(){
    var main=document.getElementById('top');if(!main)return;
    main.querySelectorAll(':scope > .tchx-sep.auto').forEach(function(n){n.remove();});
    var list=Array.prototype.filter.call(main.children,function(el){return el.offsetHeight>0&&!/^(SCRIPT|STYLE|TEMPLATE|svg)$/i.test(el.nodeName);});
    for(var i=1;i<list.length;i++){
      var a=list[i-1],b=list[i];
      if(a.classList.contains('tchx-sep')||b.classList.contains('tchx-sep'))continue;
      if(bgOf(a)===bgOf(b)){var s=document.createElement('div');s.className='tchx-sep auto';s.setAttribute('aria-hidden','true');s.innerHTML='<span></span><i></i><span></span>';s.style.background=bgOf(a);main.insertBefore(s,b);}
    }
  }
  seps();
  new MutationObserver(function(){setTimeout(seps,60);}).observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});

  /* Traduction complète des pages en anglais */
  if(LANG==='en'){T(document.body);document.documentElement.classList.remove('tchx-pending');}
});
